import { forwardRef, createElement } from 'react';

function IconInboxEinvoicing(props, svgRef) {
  return createElement("svg", Object.assign({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.997v2H6.918l-2.8 8h3.229a1 1 0 01.916.598l.974 2.221a1 1 0 00.916.598h3.694a1 1 0 00.915-.598l.976-2.22a1 1 0 01.915-.599h3.228l-.525-1.5h2.118l.428 1.22c.065.185.098.38.098.578v3.952a1.75 1.75 0 01-1.607 1.744l-.143.006H3.75A1.75 1.75 0 012 18.247v-3.952c0-.197.033-.393.098-.578L5.09 5.169a1.75 1.75 0 011.652-1.172H12zM17.966 1c2.373 0 4.052 1.688 4.052 3.99 0 .988-.267 1.349-1.03 1.386l-.14.003h-4.72v.404c.01 1.301.836 2.136 2.216 2.136.64 0 1.114-.139 1.502-.41l.403-.307c.267-.196.425-.276.705-.276.483 0 .817.334.817.844 0 .367-.2.72-.554 1.016l-.278.216c-.63.455-1.627.727-2.745.727-2.653 0-4.32-1.515-4.416-4.023l-.005-.23V5.27c0-2.547 1.688-4.27 4.193-4.27zM18 2.763c-1.09 0-1.805.769-1.868 1.932l-.004.186h3.674v-.017c0-1.275-.703-2.101-1.802-2.101z",
    fill: "currentColor"
  }));
}

var InboxEinvoicing = /*#__PURE__*/forwardRef(IconInboxEinvoicing);

export default InboxEinvoicing;
//# sourceMappingURL=InboxEinvoicing.js.map
